import React, { useState } from 'react';
import { ImCancelCircle } from "react-icons/im";
import Line from '../Line/Line';
import { HRMS_API_URL, HRMS_ORG_ID } from '../../config';

export default function ApplyFormModal({ jobId, jobTitle, isOpen, onClose }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    skills: "",
    coverLetter: "",
    resume: null,
  });

  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  if (!isOpen) return null;

  const handleSubmitForm = async (e) => {
    e.preventDefault();

    if (
      !form.name ||
      !form.email ||
      !form.phone ||
      !form.experience ||
      !form.skills ||
      !form.coverLetter ||
      !form.resume
    ) {
      alert("Please fill in all the required fields.");
      return;
    }

    setSubmitting(true);
    setErrorMsg("");

    const formData = new FormData();
    formData.append("jobId", jobId);
    formData.append("job_id", jobId);
    formData.append("name", form.name);
    formData.append("email", form.email);
    formData.append("phone", form.phone);
    formData.append("experience", form.experience);
    formData.append("skills", form.skills);
    formData.append("coverLetter", form.coverLetter);
    formData.append("cover_letter", form.coverLetter);
    formData.append("resume", form.resume);

    if (HRMS_ORG_ID && HRMS_ORG_ID !== "YOUR_ORG_ID") {
      formData.append("orgId", HRMS_ORG_ID);
      formData.append("org_id", HRMS_ORG_ID);
    }

    try {
      const response = await fetch(`${HRMS_API_URL}/applications`, {
        method: "POST",
        body: formData,
      });

      const responseData = await response.json().catch(() => ({}));

      if (response.ok || response.status === 200 || response.status === 201 || responseData.success) {
        setSuccess(true);
        setForm({
          name: "",
          email: "",
          phone: "",
          experience: "",
          skills: "",
          coverLetter: "",
          resume: null,
        });
      } else {
        setErrorMsg(responseData.message || "Failed to submit application. Please try again.");
      }
    } catch (err) {
      console.error("Submission Error:", err);
      setErrorMsg("Unable to connect to HRMS server. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setSuccess(false);
    setErrorMsg("");
    onClose();
  };

  return (
    <div className="form__background">
      <div className="form__container" style={{ position: 'relative' }}>
        <div className='form__closeButton' onClick={handleClose} style={{ cursor: 'pointer' }}>
          <ImCancelCircle size={20} />
        </div>
        <h3 className="heading1">APPLY FOR THE POSITION</h3>
        {jobTitle && <p style={{ fontSize: '14px', fontWeight: 'bold', color: 'var(--themeOrange)', margin: '5px 0 10px 0' }}>Job: {jobTitle}</p>}
        <Line width={"100%"} />

        {success ? (
          <div style={{ textAlign: 'center', padding: '30px 10px' }}>
            <p style={{ color: 'green', fontSize: '20px', fontWeight: 'bold', marginBottom: '15px' }}>
              Application submitted successfully!
            </p>
            <p style={{ color: '#555', fontSize: '16px', lineHeight: '1.6' }}>
              Thank you for applying. Our recruitment team will review your application.
            </p>
            <button 
              onClick={handleClose} 
              className="form__submit__but" 
              style={{ marginTop: '20px', borderRadius: '4px', cursor: 'pointer' }}
            >
              Close Window
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmitForm} style={{ marginTop: '15px' }}>
            <div className="form__inner__Box">
              <div className="form__input__Box">
                <label>Full Name <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="text" 
                  value={form.name} 
                  name="name" 
                  required
                  disabled={submitting}
                  onChange={(e) => setForm({ ...form, name: e.target.value })} 
                />
              </div>
              <div className="form__input__Box">
                <label>Email <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="email" 
                  value={form.email} 
                  name="email" 
                  required
                  disabled={submitting}
                  onChange={(e) => setForm({ ...form, email: e.target.value })} 
                />
              </div>
            </div>

            <div className="form__inner__Box">
              <div className="form__input__Box">
                <label>Phone <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="text" 
                  value={form.phone} 
                  name="phone" 
                  required
                  disabled={submitting}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^[0-9+() -]*$/.test(val)) {
                      setForm({ ...form, phone: val });
                    }
                  }} 
                />
              </div>
              <div className="form__input__Box">
                <label>Experience <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="text" 
                  value={form.experience} 
                  name="experience" 
                  placeholder="e.g. 2 Years / Fresher"
                  required
                  disabled={submitting}
                  onChange={(e) => setForm({ ...form, experience: e.target.value })} 
                />
              </div>
            </div>

            <div className="form__inner__Box">
              <div className="form__input__Box" style={{ width: '100%' }}>
                <label>Skills <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="text" 
                  value={form.skills} 
                  name="skills" 
                  placeholder="e.g. React, Node.js, Express" 
                  required
                  disabled={submitting}
                  onChange={(e) => setForm({ ...form, skills: e.target.value })} 
                />
              </div>
            </div>

            <div className="form__inner__Box">
              <div className="form__input__Box" style={{ width: '100%' }}>
                <label>Cover Letter <span style={{ color: 'red' }}>*</span></label>
                <textarea 
                  value={form.coverLetter} 
                  name="coverLetter" 
                  required 
                  rows="4"
                  disabled={submitting}
                  placeholder="Tell us why you are a great fit for this role..."
                  style={{
                    outline: 'none',
                    border: '1px solid #cbd5e1',
                    borderRadius: '6px',
                    padding: '10px 12px',
                    fontFamily: 'inherit',
                    width: '100%',
                    resize: 'vertical',
                    boxSizing: 'border-box',
                    fontSize: '14px',
                    color: '#0f172a'
                  }}
                  onChange={(e) => setForm({ ...form, coverLetter: e.target.value })} 
                />
              </div>
            </div>

            <div className="form__inner__Box">
              <div className="form__input__Box" style={{ width: '100%' }}>
                <label>Upload Resume <span style={{ color: 'red' }}>*</span></label>
                <input 
                  type="file" 
                  name="resume" 
                  accept=".pdf,.doc,.docx"
                  required
                  disabled={submitting}
                  onChange={(e) => setForm({ ...form, resume: e.target.files[0] })} 
                />
              </div>
            </div>

            {errorMsg && <p className="res-message" style={{ color: 'red', marginTop: '10px' }}>{errorMsg}</p>}
            
            <div style={{ marginTop: '20px' }}>
              <button 
                type="submit" 
                className="form__submit__but" 
                disabled={submitting}
                style={{ cursor: submitting ? 'not-allowed' : 'pointer' }}
              >
                {submitting ? "Submitting..." : "Submit Application"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
